import { createSelector } from "reselect";

const paymentSelector = (state) => state.payment;

export const selectPayments = createSelector(
  paymentSelector,
  (state) => state.payments
);
